import styled from 'styled-components';

export const BottomContainer = styled.div`
  display: flex;
  justify-content: end;
`;
